var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.dismissed)?_c('span',{staticClass:"Vlt-badge",class:_vm.classObject,attrs:{"id":_vm.id}},[_vm._t("default"),(_vm.dismissable)?_c('button',{staticClass:"Vlt-badge__dismiss",on:{"click":function($event){return _vm.dismiss($event)}}}):_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }